import { AdjustmentsHorizontalIcon } from "@heroicons/react/24/outline";
import { lazy } from "react";

import type { FeatureMetadata } from "../../feature.types";
import { buildCrudPermissions } from "../../shared/featureFactories";

export const FeeSetupFeature: FeatureMetadata = {
  id: "fee-setup",
  moduleName: "feesFinance",
  navigation: {
    label: "Fee Setup",
    path: "/fee-setup",
    icon: AdjustmentsHorizontalIcon,
    order: 2,
  },
  route: {
    path: "/fee-setup",
    element: lazy(() => import("./pages/AdminFeeStructure")),
  },
  permissions: buildCrudPermissions("FeeFinance", "FeeSetup"),
  readiness: "live",
};
